<template>
    <div class="um">
        <div class="um__header">
            <svg class="um__icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="4" width="18" height="18" rx="2" stroke="#C59014" stroke-width="1.5"/>
                <path d="M16 2V6" stroke="#C59014" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M8 2V6" stroke="#C59014" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M3 10H21" stroke="#C59014" stroke-width="1.5"/>
            </svg>
            <h3 class="um__title">НАСТУПНІ МАТЧІ</h3>
            <div class="um__toggle">
                <button
                    type="button"
                    class="um__toggle-btn"
                    :class="{ 'um__toggle-btn--active': source === 'uaf_pro_liha' }"
                    @click="setSource('uaf_pro_liha')"
                >
                    Про ліга
                </button>
                <button
                    type="button"
                    class="um__toggle-btn"
                    :class="{ 'um__toggle-btn--active': source === 'koaf_vishcha' }"
                    @click="setSource('koaf_vishcha')"
                >
                    Чемпіонат області
                </button>
            </div>
            <span class="um__badge">{{ badgeLabel }}</span>
        </div>

        <div class="um__list" v-if="upcomingMatches.length > 0">
            <div v-for="(match, idx) in upcomingMatches" :key="match.id" class="um__item">
                <div class="um__date-block">
                    <span class="um__date">{{ formatDate(match.date) }}</span>
                    <span class="um__time">{{ match.time || '' }}</span>
                </div>
                <div class="um__match-info">
                    <span class="um__match-title">{{ match.title }}</span>
                </div>
                <div class="um__indicator" :class="idx === 0 ? 'um__indicator--next' : ''"></div>
            </div>
        </div>

        <div v-else class="um__empty">
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" opacity="0.2">
                <rect x="3" y="4" width="18" height="18" rx="2" stroke="#C59014" stroke-width="1.5"/>
                <path d="M16 2V6" stroke="#C59014" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M8 2V6" stroke="#C59014" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M3 10H21" stroke="#C59014" stroke-width="1.5"/>
            </svg>
            <span>{{ loading ? 'Завантаження...' : 'Немає запланованих матчів Колоса' }}</span>
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted, inject, watch } from 'vue'
import { getKolosUpcomingMatches } from '@/services/apiRequests'

export default {
    name: 'UpcomingMatches',

    setup() {
        const upcomingMatches = ref([])
        const loading = ref(false)
        const source = ref('uaf_pro_liha')
        const sharedProLihaAge = inject('proLihaAge', null)
        const selectedAge = sharedProLihaAge || ref('U17')

        const badgeLabel = computed(() =>
            source.value === 'koaf_vishcha' ? 'КОАФ · Колос' : 'UAF · Колос'
        )

        const formatDate = (date) => {
            if (!date) return ''
            const d = new Date(date)
            if (Number.isNaN(d.getTime())) {
                // Already YYYY-MM-DD
                const parts = String(date).split('-')
                if (parts.length === 3) return `${parts[2]}.${parts[1]}.${parts[0]}`
                return String(date)
            }
            const day = String(d.getDate()).padStart(2, '0')
            const month = String(d.getMonth() + 1).padStart(2, '0')
            const year = d.getFullYear()
            return `${day}.${month}.${year}`
        }

        const loadUpcomingMatches = async () => {
            loading.value = true
            try {
                const age = source.value === 'koaf_vishcha' ? undefined : selectedAge.value
                const data = await getKolosUpcomingMatches(8, age, source.value)
                upcomingMatches.value = Array.isArray(data) ? data : []
            } catch (e) {
                upcomingMatches.value = []
            } finally {
                loading.value = false
            }
        }

        const setSource = (nextSource) => {
            if (source.value === nextSource) return
            source.value = nextSource
            loadUpcomingMatches()
        }

        onMounted(loadUpcomingMatches)

        if (sharedProLihaAge) {
            watch(sharedProLihaAge, () => {
                if (source.value === 'uaf_pro_liha') {
                    loadUpcomingMatches()
                }
            })
        }

        return {
            upcomingMatches,
            loading,
            source,
            badgeLabel,
            formatDate,
            setSource
        }
    }
}
</script>

<style scoped>
.um {
    background: linear-gradient(180deg, #1c1c1e 0%, #161618 100%);
    border: 1px solid rgba(255, 255, 255, 0.04);
    border-radius: 16px;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.um__header {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 14px 18px;
    background: rgba(197, 144, 20, 0.04);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    flex-wrap: wrap;
}

.um__title {
    color: #fff;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 1.2px;
    text-transform: uppercase;
}

.um__toggle {
    display: flex;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    overflow: hidden;
    margin-left: auto;
}

.um__toggle-btn {
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.45);
    font-size: 11px;
    font-weight: 600;
    padding: 6px 10px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.um__toggle-btn--active {
    background: rgba(197, 144, 20, 0.25);
    color: #C59014;
}

.um__badge {
    font-size: 10px;
    color: rgba(197, 144, 20, 0.8);
    background: rgba(197, 144, 20, 0.1);
    border: 1px solid rgba(197, 144, 20, 0.2);
    border-radius: 999px;
    padding: 3px 8px;
    font-weight: 600;
}

.um__list {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #333 transparent;
}

.um__item {
    display: flex;
    align-items: center;
    padding: 12px 18px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
    transition: background-color 0.15s;
    position: relative;
}

.um__item:hover {
    background: rgba(255, 255, 255, 0.02);
}

.um__date-block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 100px;
    margin-right: 14px;
}

.um__date {
    color: #C59014;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
}

.um__time {
    color: rgba(255, 255, 255, 0.3);
    font-size: 11px;
    margin-top: 2px;
}

.um__match-info {
    flex: 1;
}

.um__match-title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    font-weight: 500;
}

.um__indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    margin-left: 10px;
}

.um__indicator--next {
    background: #8FC408;
    box-shadow: 0 0 8px rgba(143, 196, 8, 0.5);
}

.um__empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 10px;
    color: rgba(255, 255, 255, 0.25);
    font-size: 13px;
}
</style>
